(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const styles = getComputedStyle(document.documentElement);
  const duration = (name) => parseFloat(styles.getPropertyValue(`--motion-${name}`)) || 240;
  const ease = styles.getPropertyValue('--motion-ease').trim() || 'cubic-bezier(.22,1,.36,1)';
  const animate = (element, keyframes, options = {}) => {
    if (preference.matches || !element.animate) return null;
    return element.animate(keyframes, { duration: duration('standard'), easing: ease, ...options });
  };
  const finished = (animation) => animation?.finished.catch(() => {}) || Promise.resolve();
  const trapFocus = (event, root) => {
    if (event.key !== 'Tab') return;
    const controls = [...root.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), summary, [tabindex="0"]')]
      .filter((element) => !element.closest('[inert]') && element.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };
  window.WTCTheme.motion = { reduced: () => preference.matches, duration, ease, animate, finished, trapFocus };

  document.documentElement.classList.add('wtc-motion-ready');
  const reveal = (element) => {
    element.removeAttribute('data-motion-pending');
    if (!preference.matches) {
      [...element.querySelectorAll('[data-reveal-group] > *')]
        .filter((child) => !child.hidden)
        .forEach((child, index) => animate(child, [
          { opacity: 0, transform: 'translateY(20px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ], { duration: duration('reveal'), delay: Math.min(index, 3) * 75, fill: 'backwards' }));
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06 }) : null;
  window.WTCTheme.register('[data-reveal], [data-aos]', (element) => {
    if (observer && !preference.matches && element.getBoundingClientRect().bottom > 0) {
      element.setAttribute('data-motion-pending', '');
      observer.observe(element);
    }
    return () => {
      observer?.unobserve(element);
      element.removeAttribute('data-motion-pending');
    };
  });
  preference.addEventListener('change', () => {
    if (preference.matches) {
      document.querySelectorAll('[data-motion-pending]').forEach(reveal);
      observer?.disconnect();
      document.getAnimations().forEach((animation) => animation.cancel());
    }
  });
})();
